export enum BodyType {
  stenen = "стенен",
  tavanen = "таванен",
  podov = "подов",
}

export interface InnerBodyType {
  image: any;
  model: string;
  price: number;
  price_eur?: number;
  type: BodyType;
}

export type InnerBodiesByType = Record<BodyType, InnerBodyType[]>;
